import React, { useState } from "react";
import "../styles/ReviewAvailablePage.css"; // ✅ 새로운 스타일 적용
import MyPageEmpty from "./MyPageEmpty";
import ReviewHistoryCard from "./ReviewHistoryCard"; // ✅ 기존 카드 재사용

const ReviewAvailableSection = ({ reviews }) => {
    // ✅ 페이지네이션 (5개씩 로드)
    const [visibleReviews, setVisibleReviews] = useState(5);

    const loadMoreReviews = () => {
        setVisibleReviews((prev) => prev + 5);
    };

    if (reviews === "noData") {
        return <MyPageEmpty text="리뷰 가능한 상품이 없습니다."/>;
    }

    return (
        <div className="review-available-section">
            {/* 데이터가 없을 경우 */}
            {reviews.length === 0 ? <MyPageEmpty /> : (
                <div className="review-available-list">
                    {reviews.slice(0, visibleReviews).map(item => (
                        <ReviewHistoryCard key={item.id} orderItem={item} />
                    ))}
                </div>
            )}

            {/* ✅ 더보기 버튼 */}
            {reviews.length > visibleReviews && (
                <button className="review-load-more-btn" onClick={loadMoreReviews}>더보기 +</button>
            )}
        </div>
    );
};

export default ReviewAvailableSection;
